import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LINKEDIN_API_URL } from '@main-client/src/app/auth/auth.helper';

import get from 'lodash-es/get';
import isEqual from 'lodash-es/isEqual';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!isEqual(LINKEDIN_API_URL, req.url)) {
      return next.handle(req);
    }
    const params = {
      code: get(req.body, 'oauthData.code'),
      clientId: get(req.body, 'authorizationData.client_id'),
      redirectUri: get(req.body, 'authorizationData.redirect_uri'),
    };
    const newReq = req.clone({
      body: {
        ...req.body,
        ...params,
      },
    });
    return next.handle(newReq);
  }
}
